<template>
  <span ref="hoverIcon" id="hoverIcon" v-if="!checkIconText" :class="{'clickable' : clickable}" class="icon--hover" aria-hidden="true" @click="onClickCopy(text)">
    <span class="fa fa-info-circle icon-color" :style="returnMousePosition"></span>
    <div class="icon--tooltip"
        :class="{
        'tooltip-top' : top,
        'tooltip-bottom' : bottom,
        'tooltip-right' : right,
        'tooltip-left' : left,
        'display-fixed' : displayFixed
      }"
      >
      <i class="text-width" v-html="renderedText" />
    </div>
  </span>

  <span ref="hoverIcon" v-else id="hoverIcon" class="icon--hover" aria-hidden="true">
    <span class="background-thing icon-color py-1 px-2" :style="returnMousePosition">{{ iconText }}</span>
    <div class="icon--tooltip"
        :class="{
        'tooltip-top' : top,
        'tooltip-bottom' : bottom,
        'tooltip-right' : right,
        'tooltip-left' : left,
        'display-fixed' : displayFixed
        }"
      >
      <div v-html="renderedText" />
    </div>
  </span>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'HoverToolTip',

  props: {
    text: String,
    top: Boolean,
    bottom: Boolean,
    right: Boolean,
    left: Boolean,
    iconText: [String, Boolean],
    iconColor: String,
    clickable: Boolean,
    displayFixed: Boolean
  },
  data () {
    return {
      isFeedbackPlay: false,
      mouseX: 0,
      mouseY: 0
    }
  },

  methods: {
    getMousePosition () {
      window.addEventListener('mousemove', _.debounce(function (e) {
        console.log(e.x, e.y)
        this.mouseX = e.x
        this.mouseY = e.y
      }, 500))
    },

    onClickCopy () {
      if (!this.clickable) return
      let fakeText = this.text

      fakeText = this.trimSpaces(fakeText)
      fakeText = this.trimSpecialChars(fakeText)
      navigator.clipboard.writeText(fakeText)
      this.playFeedback()
    },

    playFeedback () {
      this.isFeedbackPlay = true

      setTimeout(() => {
        this.isFeedbackPlay = false
      }, 1000)
    },

    trimSpaces (text) {
      text = text.replace(/ {2}/g, '')
      text = text.trim()

      return text
    },

    trimSpecialChars (text) {
      // text = text.replace(/<strong>/g, '')
      // text = text.replace(/<\/strong>/g, '')
      // text = text.replace(/<br>/g, '')
      text = text.replace(/<.*>/g, '')

      return text
    }
  },

  // mounted () {
  //   if (this.displayFixed) this.getMousePosition()
  // },
  // destroyed () {
  //   window.removeEventListener('mousemove', this.getMousePosition)
  // },

  computed: {
    checkIconText () {
      if (this.iconText === false || this.iconText === '' || typeof this.iconText === 'undefined') return false
      else return true
    },

    renderedText () {
      if (this.isFeedbackPlay) return this.$t('HoverToolTip.copied')
      else return this.trimSpaces(this.text)
    },

    returnIconColor () {
      return {
        '--icon-color': this.iconColor
      }
    },

    returnMousePosition () {
      return {
        '--mouse-position-x': this.mouseX,
        '--mouse-position-y': this.mouseY,
        '--icon-color': this.iconColor
      }
    }
  }

}
</script>

<style scoped>
  button {
    border: none;
    border-radius: 0px;
  }

  .clickable {
    cursor: pointer !important;
  }

  .icon--hover {
    color: #f7941e;
    position: relative;
    text-align: center;
  }

  .icon--hover .icon--tooltip {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.8rem;
    background: #e88b1a;
    border-radius: 3px;
    color: white;
    margin-bottom: 10px;
    opacity: 0;
    padding: 8px;
    pointer-events: none;
    width: relative;
    -webkit-transform: translateY(10px);
    -moz-transform: translateY(10px);
    -ms-transform: translateY(10px);
    -o-transform: translateY(10px);
    transform: translateY(10px);
    -webkit-transition: all .25s ease-out;
    -moz-transition: all .25s ease-out;
    -ms-transition: all .25s ease-out;
    -o-transition: all .25s ease-out;
    transition: all .25s ease-out;
    -webkit-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -moz-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -ms-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -o-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
  }
  .icon--tooltip {
    position: absolute;
    max-width: auto;
    min-width: 275px;
    z-index: 999999;
  }

  .tooltip-top {
    bottom: 40%;
  }

  .tooltip-bottom {
    top: 80%;
  }
  .tooltip-left {
    right: 80%;
  }

  .tooltip-right {
    left: 80%;
  }

  .icon--hover:hover .icon--tooltip {
    opacity: 1;
    pointer-events: auto;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  .background-thing {
    font-size: 0.8rem;
    background-color: rgb(255, 255, 255);
    border-radius: 5rem;
    padding: 0.25rem 0.25rem 0.25rem 0.25rem;
  }
  .icon-color {
    color: var(--icon-color);
  }
  .display-fixed {
    position: fixed !important;
    top: 450px;
    left: 290px;
    color: var(--icon-color);
  }
</style>
